export default __webpack_public_path__ + "static/media/home-dentist-img-01.1a22de33.jpg";